module.exports = __webpack_public_path__ + "img/fhlcgongzhonghao.c972d309.jpg";